var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"d-flex mt-2",attrs:{"show":"","variant":"warning","dismissible":""}},[_c('div',{staticClass:"d-flex flex-grow-0 align-items-center"},[_c('b-img',{staticClass:"alert-icon",attrs:{"src":_vm.AlertOrange,"alt":"info icon"}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }